// extracted by mini-css-extract-plugin
export var numberInputContainer = "_61-0";
export var startPickingButton = "_61-1";